import React from 'react';
import { cn } from '@/lib/cn';

export interface SelectionProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Whether this option is selected */
  selected?: boolean;
  /** Optional leading icon element (24px) */
  leadingIcon?: React.ReactNode;
  /** Optional trailing element (e.g., checkbox) */
  trailing?: React.ReactNode;
  /** Optional subtitle text */
  subtitle?: React.ReactNode;
  /** Label content. Typically plain text. */
  children?: React.ReactNode;
}

export function Selection({
  selected = false,
  leadingIcon,
  trailing,
  subtitle,
  children,
  className,
  ...props
}: SelectionProps) {
  return (
    <div
      className={cn(
        // layout
        'flex items-center gap-4',
        'px-4 py-3',
        'rounded-full',
        'border',
        // background colors
        selected
          ? 'bg-active hover:bg-active-hover ring-accent ring-inset ring-1 border-accent'
          : 'bg-primary hover:bg-primary-hover border-secondary',
        // cursor
        'cursor-pointer',
        className,
      )}
      {...props}
    >
      {leadingIcon ? (
        <div className="w-6 h-6 shrink-0 flex items-center justify-center">{leadingIcon}</div>
      ) : null}
      <div className="flex-1 min-w-0 flex flex-col gap-1">
        <span className="text-body-2 text-primary truncate">{children}</span>
        {subtitle && <span className="text-caption text-secondary truncate">{subtitle}</span>}
      </div>
      {trailing ? <div className="shrink-0">{trailing}</div> : null}
    </div>
  );
}

export default Selection;
